<div *ngIf="open && version" class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
  <div class="max-h-[85vh] w-full max-w-3xl overflow-auto rounded-3xl bg-white p-6 dark:bg-[#0e1726]">
    <div class="mb-4 flex items-center justify-between">
      <h3 class="text-base font-semibold text-gray-800 dark:text-white">
        Version v{{ version.version_seq }} · {{ version.status }}
      </h3>
      <button type="button" class="text-gray-400 hover:text-gray-700 dark:hover:text-white" (click)="close.emit()">✕</button>
    </div>

    <p *ngIf="version.restore_tag" class="mb-4 rounded-lg bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:bg-white/5 dark:text-gray-300">{{ version.restore_tag }}</p>

    <app-rule-config-view [config]="version.payload" [lockedKeys]="lockedKeys" [diff]="version.field_diff"></app-rule-config-view>

    <div class="mt-5 flex items-center gap-3">
      <button
        type="button"
        class="btn inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-medium dark:border-[#191e3a] dark:bg-[#0e1726]"
        [disabled]="validating"
        (click)="validate.emit(version)"
      >
        <span *ngIf="validating" class="inline-block size-3 animate-spin rounded-full border-2 border-gray-400/40 border-t-gray-700 dark:border-t-white"></span>
        Validate
      </button>
    </div>

    <div *ngIf="preview" class="mt-4 rounded-2xl border p-4"
         [class.border-emerald-200]="preview.is_valid" [class.bg-emerald-50]="preview.is_valid"
         [class.border-red-200]="!preview.is_valid" [class.bg-red-50]="!preview.is_valid">
      <p class="text-sm font-semibold" [class.text-emerald-800]="preview.is_valid" [class.text-red-800]="!preview.is_valid">
        {{ preview.is_valid ? 'Valid — passes business rules and compliance locks' : 'Invalid' }}
      </p>
      <ul *ngIf="preview.validation_errors.length" class="mt-2 list-disc pl-5 text-xs text-red-800">
        <li *ngFor="let e of preview.validation_errors">{{ e }}</li>
      </ul>
      <ul *ngIf="preview.compliance_violations.length" class="mt-2 list-disc pl-5 text-xs text-red-800">
        <li *ngFor="let v of preview.compliance_violations">
          {{ v.parameter }}: requires {{ v.required }}, got {{ v.provided }} ({{ v.regulation }})
        </li>
      </ul>
    </div>
  </div>
</div>
